import React, { useEffect, useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Input, InputMask, Line, Grid } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { SPACING } from 'utils'
import * as Yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalEditTalkWithUs.styles'

interface IModalEditTalkWithUs {
  isOpen: boolean
  onClose: () => void
  title: string
  handleEdit: (data: any) => void
  formValue: any
}

// interface IFormValue {
//   dsMotivo: string
//   dsEmail: string
// }

interface ITalkWithUsFields {
  email: string
  reason: string
}

const ModalEditTalkWithUs: React.FC<IModalEditTalkWithUs> = ({
  isOpen,
  onClose,
  title,
  handleEdit,
  formValue
}) => {
  const schema = Yup.object({
    email: Yup.array().of(
      Yup.object().shape({
        dsEmail: Yup.string()
          //.email('E-mail inválido')
          .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
          .required('Digite o e-mail')
      })
    ),
    reason: Yup.string().required('Digite o motivo')
  })

  const {
    setValue,
    control,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm<ITalkWithUsFields>({
    mode: 'onChange',
    resolver: yupResolver(schema)
  })

  const [emails, setEmails] = useState<{ dsEmail: string; id: number }[]>(
    formValue.emails.map((email, index) => ({
      dsEmail: email.dsEmail,
      id: index
    }))
  )

  const handleSubmitEditing = (data) => {
    const sameEmail = data.email === formValue.dsEmail
    const sameReason = data.reason === formValue.emails
    if (sameEmail && sameReason) {
      // setError("email", {
      //   message: "Nenhum campo foi alterado",
      //   type: "manual",
      // })
      onClose()
      return
    }
    handleEdit(data)
  }

  const handleNewItem = () => {
    setEmails([
      ...emails,
      { dsEmail: '', id: emails[emails.length - 1].id + 1 }
    ])
  }

  const handleDelete = (id: number) => {
    const cpyArr = emails.slice()

    setEmails(cpyArr.filter((email) => email.id !== id))
    setValue('email', JSON.stringify(cpyArr.filter((email) => email.id !== id)))
  }

  useEffect(() => {
    setValue('email', formValue.emails)
  }, [])

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      width={'md'}
      showModal={isOpen}
      onClose={onClose}
    >
      <Line />
      <FormDialog
        onSubmit={handleSubmit((data) => {
          handleSubmitEditing(data)
          resetModalState(draggableReference)
        })}
      >
        <DialogTitleStyled>{title}</DialogTitleStyled>

        <DialogContentStyled>
          <InputMask
            defaultValue={formValue.dsMotivo}
            control={control}
            errors={errors}
            formValue={'reason'}
            label="Motivo"
            placeholder="Informe o Motivo"
            maxLength={50}
            type="alfanumeric"
          />
        </DialogContentStyled>

        <DialogContentStyled>
          {emails.map((email, index) => (
            <Grid
              gridCols="5fr 1fr 1fr"
              gridGap={`0 ${SPACING.spacing20}`}
              margin={`0 0 ${SPACING.spacing30} 0`}
            >
              <Input
                key={email.id}
                value={email.dsEmail}
                onChange={(event) => {
                  setEmails((oldState) => {
                    oldState[index].dsEmail = event.target.value
                    return [...oldState]
                  })
                }}
                onBlur={(e) => {
                  const copyValue = emails
                  copyValue[index].dsEmail = e.target.value
                  setValue('email', JSON.stringify(copyValue))
                  setEmails(copyValue)
                }}
                formValue={'email'}
                label="E-mail Destinatário (Grupos)"
                placeholder="Informe os Emails"
                maxLength={50}
              />
              <Button text="+" onClick={handleNewItem} />
              {emails.length === 1 ? (
                <Button text=" " variantButton="text" disabled />
              ) : (
                <Button text="-" onClick={() => handleDelete(email.id)} />
              )}
            </Grid>
          ))}
        </DialogContentStyled>

        <DialogActionsStyled>
          <Button
            text="Voltar"
            variantButton="outlined"
            onClick={() => {
              resetModalState(draggableReference)
              onClose()
            }}
          />
          <Button text="Salvar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalEditTalkWithUs
